<script>
    export let size = "big";
</script>

<style>
    .big{
        border: 16px solid #222222; /* Light grey */
        border-top: 16px solid #ffffff; /* Blue */
        width: 120px;
        height: 120px;
    }
    .small{
        border: 2px solid #f3f3f3; /* Light grey */
        border-top: 2px solid #222222; /* Blue */
        width: 12px;
        height: 12px;
    }


    .loader {
        border-radius: 50%;

        animation: spin 2s linear infinite;
    }
    .loading{
        display: flex;
        flex-direction: row;
        align-items: center;

    }

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
</style>

<span class="loading">
    <span class="loader {size}"></span>
</span>
